import React, { Component } from 'react';
import { get, post } from 'axios';
import ProposalServices from './ProposalServices';
import ProposalLineitem from './ProposalLineitem';
import Notifications, {notify} from 'react-notify-toast';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { inject, observer } from 'mobx-react';

@inject('userStore')
@observer
class BookingInvoice extends Component {
    constructor(props){
        super(props);
        this.state = {
            lineitem_list:[],
            invoiceLineitemList:[],
            service_list:[],
            service_total:0,
            lineitem_total:0,
            event_total:0,
            bk_invoice_hash_id:'',
            is_published:null,
            invoice:null,
            availableServiceList:[],
            quickviewVisible:false,
            invoicedServiceList:[]
        }
        this.addLineitem = this.addLineitem.bind(this);
        this.backHandler = this.backHandler.bind(this);
        this.addLineitem = this.addLineitem.bind(this);
        this.deleteLineitem = this.deleteLineitem.bind(this);
        this.getInvoice = this.getInvoice.bind(this);
        this.sendInvoice = this.sendInvoice.bind(this);
        this.addService = this.addService.bind(this);
        this.openQuickView = this.openQuickView.bind(this);
    }

    componentDidMount(){
        this.getInvoice();
        post('/v2/get/lineitems', {bk_hash_id: this.props.booking.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            this.setState({
              lineitem_list: res.data.lineitem_list
            })
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    sendInvoice(){
        post('/v2/send/invoice', {bk_hash_id: this.props.booking.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors == 0){
                if (res.data.invoice){
                    console.log(this.props.booking.current_stage_id);
                    this.setState({
                        is_published:res.data.invoice.is_published
                    }, () => {this.props.booking.current_stage_id = res.data.current_stage_id})
                    console.log(this.props.booking.current_stage_id);
                }
                notify.show('Email sent', "success", 1000);
            } else {
                notify.show('Error occurred: '+ res.data.message, "error", 1000);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    publishedOnChange(event, invoice){
      if (event.target.checked){
        invoice.is_published = 1;
      } else {
        invoice.is_published = 0;
      }
      // save this
      post('v2/save/invoice_publish', {
        invoice_hash_id: invoice.hash_id,
        is_published: invoice.is_published
      }, {
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        alert(res.data.message);
        if (res.data.errors === 0){
          this.setState({
            invoice:invoice
          })
        }
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    getInvoice(){
      console.log(this.props.invoice);
        post('/v2/get/invoice', {bk_invoice_hash_id: this.props.invoice.hash_id}, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
          console.log(res.data.invoice)
            if (res.data.invoice){
                this.setState({
                    invoice:res.data.invoice,
                    service_list:res.data.invoice.service_list,
                    service_total:res.data.invoice.service_total,
                    lineitem_total:res.data.invoice.lineitem_total,
                    invoiceLineitemList:res.data.invoice.lineitem_list,
                    event_total:res.data.invoice.event_total,
                    bk_invoice_hash_id:res.data.invoice.hash_id,
                    is_published:res.data.invoice.is_published,
                    availableServiceList:res.data.invoice.available_service_list,
                    invoicedServiceList:res.data.invoice.invoiced_service_list,
                    is_published:res.data.invoice.is_published
                })
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    openQuickView(){
        this.setState({
            quickviewVisible:!this.state.quickviewVisible
        })
    }

    addService(service){
        console.log(service);
        post('/v2/save/invoice_service', {hash_id: this.state.invoice.hash_id, bk_service_id:service.id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // reload with the new lineitem
                if (res.data.invoice){
                    this.setState({
                        service_list:res.data.invoice.service_list,
                        service_total:res.data.invoice.service_total,
                        event_total:res.data.invoice.event_total,
                        availableServiceList:res.data.invoice.available_service_list,
                        invoicedServiceList:res.data.invoice.invoiced_service_list,
                        lineitem_total:res.data.invoice.lineitem_total,
                        invoiceLineitemList:res.data.invoice.lineitem_list
                    })
                }
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    addLineitem(lineitem){
        post('/v2/save/lineitem', {hash_id: this.state.invoice.hash_id, typeof:'invoice', description:lineitem.description, bus_lineitem_id:lineitem.id, price_override:lineitem.default_amount, quantity:lineitem.quantity},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // reload with the new lineitem
                if (res.data.invoice){
                    this.setState({
                        service_list:res.data.invoice.service_list,
                        service_total:res.data.invoice.service_total,
                        lineitem_total:res.data.invoice.lineitem_total,
                        invoiceLineitemList:res.data.invoice.lineitem_list,
                        event_total:res.data.invoice.event_total,
                        bk_invoice_hash_id:res.data.invoice.hash_id
                    })
                }
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    deleteLineitem(lineitem){
        post('/v2/delete/lineitem', {hash_id: this.state.invoice.hash_id, bk_lineitem_id:lineitem.id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // reload with the new lineitem
                if (res.data.invoice){
                    this.setState({
                        service_list:res.data.invoice.service_list,
                        service_total:res.data.invoice.service_total,
                        lineitem_total:res.data.invoice.lineitem_total,
                        invoiceLineitemList:res.data.invoice.lineitem_list,
                        event_total:res.data.invoice.event_total,
                        bk_invoice_hash_id:res.data.invoice.hash_id,
                        availableServiceList:res.data.invoice.available_service_list,
                        invoicedServiceList:res.data.invoice.invoiced_service_list
                    })
                }
                notify.show('Item deleted', "success", 1000);
            } else {
                notify.show('Error occurred: '+ res.data.message, "error", 1000);
            }
        }).catch((error) => {
            notify.show('Error occurred: '+ error, "error", 1000);
            console.log(error);
            return error;
        });
    }


    backHandler(){
        this.props.backHandler();
    }

    render() {
        if (!this.props.invoice || !this.state.invoice) return <div className="alert alert-danger">No Invoice Loaded</div>;
        const {invoice} = this.state;
        const CheckBox = props => {
            const checked = props.is_published === 1 ? "checked" : null;
            return <input {...props} checked={checked}/>
        };
        return (
            <React.Fragment>
            <Notifications />
            <div className="main-content pt-20">
                <header className="header header-transparent">
                    <div className="header-info mb-0">
                        <div className="left">
                            <h2 className="header-title">{this.props.invoice.description} <small className="subtitle">{this.props.booking.full_name}<br/>{this.props.booking.date} @ {this.props.booking.ready_time}</small></h2>
                            {this.state.is_published ? <p className="text-success">Invoice is <strong>PUBLISHED</strong> do not make changes as client may make payment.</p> : <p className="text-warning">Invoice has not been published.</p>}
                        </div>
                        <div className="right gap-items-2">
                            <a className="btn btn-secondary btn-square btn-round" onClick={this.backHandler}><i className="fa fa-remove"></i></a>
                        </div>
                    </div>
                </header>
                <div className="card form-type-combine">
                    <ProposalServices service_list={this.state.service_list} lineitem_list={this.state.invoiceLineitemList} service_total={this.state.service_total} lineitem_total={this.state.lineitem_total} event_total={this.state.event_total} deleteHandler={this.deleteLineitem} for_booking={true} openQuickView={this.openQuickView}/>
                    <div className="card-body">
                        <div className="row">
                        {this.state.lineitem_list.map((lineitem, index) =>
                            <div className="col-sm-6 col-md-4" key={index}>
                                <ProposalLineitem lineitem={lineitem} handler={this.addLineitem}/>
                            </div>
                        )}
                        </div>
                    </div>
                    <footer className="card-footer">
                        <div className="pull-left">
                            {invoice.is_published ? <p className="text-success">Invoice is PUBLISHED</p> : <p className="text-warning">Invoice is not published</p>}
                        </div>
                        <label className="switch switch-lg ml-10">
                            <CheckBox type="checkbox" is_published={invoice.is_published} onChange={(event) => this.publishedOnChange(event, invoice)}/>
                            <span className="switch-indicator"></span>
                        </label>
                        <div className="btn-group pull-right">
                            <button className="btn btn-secondary" onClick={this.backHandler}>Back</button>
                            <button className="btn btn-primary" onClick={this.sendInvoice}>Send</button>
                        </div>
                    </footer>
                </div>
            </div>
            <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.availableServiceList ?
                <React.Fragment>
                <header className="quickview-header">
                    <p className="quickview-title lead fw-400">Add Services</p>
                    <span className="close" onClick={() => this.setState({quickviewVisible:false})}><i className="ti-close"></i></span>
                </header>
                <PerfectScrollbar>
                <div className="quickview-body">
                    <div className="quickview-block form-type-material">
                        <div className="card card-bordered">
                            <div className="media-list media-list-hover media-list-divided">
                            {this.state.availableServiceList.map((service, index) =>
                                <div key={index} className="media media-single">
                                    <div className="media-body">
                                      <strong>{service.name}</strong>
                                      {this.state.invoicedServiceList.includes(service.id) ? <React.Fragment><br/><span className="badge badge-danger">Already Invoiced</span></React.Fragment> : null}
                                    </div>
                                    <div className="media-right">
                                        <button className="btn btn-float btn-sm btn-success" onClick={() => this.addService(service)}><i className="fa fa-plus"></i></button>
                                    </div>
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
                </PerfectScrollbar>
                <footer className="p-12 text-center">
                  <div className="btn-group btn-block btn-group-vertical">
                      <button className="btn btn-lg btn-outline btn-block btn-info" onClick={() => this.setState({quickviewVisible:false})}><i className="fa fa-fw fa-close"></i> Close</button>
                  </div>
                </footer>
                </React.Fragment>
                :
                <div>Loading</div>
            }
            </div>
            </React.Fragment>
        )
  }
}

export default BookingInvoice;



// WEBPACK FOOTER //
// ./src/components/business/BookingInvoice.js